import { UPDATE_SHARD_ID } from '../actions';
import { Reducer } from 'redux';

export const shardId: Reducer<string> = (state = '', action) => {
  switch (action.type) {
    case UPDATE_SHARD_ID: {
      return action.shardId;
    }
    default:
      return state;
  }
};
